import React from "react";

// components
import CommonForm from "../Common/CommonForm";
import BaseApi from "../../utils/BaseApi";
import CommonStepper from "../Common/CommonStepper";
import {retrieveModelField} from "../../utils/misc";

// icons
import {CircularProgress} from "@mui/joy";


class LeadConvert extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            account: null,
            contact: null,
            opportunity: null,
            formFields: null,
        };
        this.steps = [
            {
                order: 0,
                title: 'Компания',
            },
            {
                order: 1,
                title: 'Контакт',
            },
        ]
        if (!this.props.noOpportunity){
            this.steps = [
                ...this.steps,
                ...[
                    {
                        order: 2,
                        title: 'Сделка',
                    },
                ]
            ]
        }

    }

    async componentDidMount() {
        let accountField = await retrieveModelField(
            'account',
            {
                page_size: 10000,
            },
            'account',
            'Компания',
            'id',
            ['nameshort',],
            'Создать новую',
            null,
            true
        )
        accountField.default = this.props.lead.account?.id
        this.setState(
            {
                formFields: [
                    accountField,
                    this.props.noOpportunity?
                        {
                            type: 'submit',
                            label: 'Конвертировать',
                        }:
                        {
                            type: 'submit',
                            label: 'Далее',
                        },
                ]
            }
        );
    }

    async processStep0(form) {
        let account = form.state.formData.get('account');
        if (account === 'NaN'){
            account = null
        }
        let contactFields = [
            {
                name: 'create_ceo',
                label: 'Создать контакт генерального директора',
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
                xl: 12,
                required: false,
                default: false,
                type: "checkbox"
            },
            {
                name: 'duplicate_contacts',
                label: 'Перенести контакты из лида в компанию',
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
                xl: 12,
                required: false,
                default: false,
                type: "checkbox"
            }
        ]
        this.setState(
            {
                account: account,
                formFields: [
                    ...contactFields,
                    {
                        type: 'submit',
                        label: 'Далее',
                    },
                ],
                activeStep: 1,
            }
        );


    }

    async processStep1(form) {
        let duplicate_contacts = form.state.formData.get('duplicate_contacts');
        let create_ceo = form.state.formData.get('create_ceo');

        if (this.props.noOpportunity){
            await this.props.callBack(
                {
                    account: this.state.account,
                    duplicate_contacts: duplicate_contacts,
                    create_ceo: create_ceo,
                    opportunity: null,
                    role: null,
                    no_opportunity: true,
                }
            )
            return
        }
        if (!this.state.account){
            await this.props.callBack(
                {
                    account: this.state.account,
                    duplicate_contacts: duplicate_contacts,
                    create_ceo: create_ceo,
                    opportunity: null,
                    role: null,
                    no_opportunity: false,
                }
            )
            return
        }
        let opportunityField = await retrieveModelField(
            'opportunity',
            {
                account: this.state.account,
                page_size: 10000,
            },
            'opportunity',
            'Сделка',
            'id',
            ['short_name',],
            'Создать новую',
            null,
            true
        )
        opportunityField.default = this.props.lead.opportunity?.id
        this.setState(
            {
                duplicate_contacts: duplicate_contacts,
                create_ceo: create_ceo,
                formFields: [
                    opportunityField,
                    {
                        type: 'submit',
                        label: 'Конвертировать',
                    },
                ],
                activeStep: 2,
            }
        );
    }

    async processStep2(form) {
        let opportunity = form.state.formData.get('opportunity');
        if (opportunity === 'NaN'){
            opportunity = null
        }
        await this.props.callBack(
            {
                account: this.state.account,
                duplicate_contacts: this.state.duplicate_contacts,
                create_ceo: this.state.create_ceo,
                contact: this.state.contact,
                opportunity: opportunity,
            }
        )
    }

    async setStep(order) {
        let formData = new FormData();
        formData.set('account', this.state.account);
        formData.set('contact', this.state.contact);
        formData.set('opportunity', this.state.opportunity);
        let formFake = {'state': {'formData': formData}}
        if (order === 0){
            await this.componentDidMount()
        }
        else {
            await this['processStep'+(order-1)](formFake)
        }
        this.setState(
            {activeStep: order}
        )
    }

    render() {
        if (!this.state.formFields) {
            return (<CircularProgress />)
        }
        if (this.state.activeStep === 0) {
            return (
                <>
                    <CommonStepper
                        steps={this.steps}
                        activeStep={this.state.activeStep}
                        callBack={this.setStep.bind(this)}
                    />
                    <CommonForm
                        fields={this.state.formFields}
                        processForm={this.processStep0.bind(this)}
                    />
                </>
            )
        }
        else if (this.state.activeStep === 1) {
            return (
                <>
                    <CommonStepper
                        steps={this.steps}
                        activeStep={this.state.activeStep}
                        callBack={this.setStep.bind(this)}
                    />
                    <CommonForm
                        fields={this.state.formFields}
                        processForm={this.processStep1.bind(this)}
                    />
                </>
            )
        }
        else if (this.state.activeStep === 2) {
            return (
                <>
                    <CommonStepper
                        steps={this.steps}
                        activeStep={this.state.activeStep}
                        callBack={this.setStep.bind(this)}
                    />
                    <CommonForm
                        fields={this.state.formFields}
                        processForm={this.processStep2.bind(this)}
                    />
                </>
            )
        }
        else if (this.state.activeStep === 3) {
            return (
                <>
                    <CommonStepper
                        steps={this.steps}
                        activeStep={this.state.activeStep}
                        callBack={this.setStep.bind(this)}
                    />
                    <CommonForm
                        fields={this.state.formFields}
                        processForm={this.processStep3.bind(this)}
                    />
                </>
            )
        }
    }
}

export default LeadConvert
